import { lazy, Suspense, useCallback, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { ContentGroups, TranslationNamespaces } from '~/lib/constants';
import { Tagged } from '~/apps/smartsend/components/Tagged';
import { useP2GMediaQueryOnly } from '@parcel2go/core-ui';
import { ContentContext } from '@parcel2go/npm-p2g-app';
import { RouteAppWrapper } from '~/components/route-app-wrapper';
import { RoutingConstants } from '~/apps/smartsend/lib/consts/RoutingConstants';
import { useParams } from 'react-router-dom';
import useGoto from '~/hooks/use-goto';
import { AppSurface } from '~/components/surface/app-surface';
import { GenerateBaseAnalyticsPayload } from '~/lib/utils/analytics';
import { NavigationContext } from '~/components/nav/nav-context';
import useOnLoad from '../use-on-load';
import useSmartSendAnalytics from '~/hooks/use-smartsend-analytics';

const NewEnquiry = lazy(() => import('~/apps/self-serve/pages/OpenEnquiry/new-enquiry'));

export default function Component() {
  const isXs = useP2GMediaQueryOnly('xs');
  const { orderid } = useParams();
  const { track } = useSmartSendAnalytics();
  const { dispatch } = useContext(ContentContext);
  const { dispatch: navigationDispatch } = useContext(NavigationContext);
  const { t } = useTranslation(TranslationNamespaces.SELFSERVE);
  const { goTo } = useGoto();

  useOnLoad(() => {
    const title = t('OPEN_ENQUIRY_PAGE_TITLE', { defaultValue: 'How Can We Help?' });
    document.title = title;
    dispatch({ type: 'SET_CONTENT_GROUP', contentGroup: ContentGroups.SELFSERVE });
    navigationDispatch({
      type: 'INITIALISE_NAVIGATION',
      payload: { title: title, currentPageRoute: RoutingConstants.Enquiry }
    });
    track({
      type: 'page_view',
      payload: {
        ...GenerateBaseAnalyticsPayload([]),
        page: RoutingConstants.Enquiry
      }
    });
  });

  const onReset = useCallback(() => {
    goTo(RoutingConstants.SupportTickets + '/' + RoutingConstants.SupportTickets_Raise);
  }, [goTo]);

  return (
    <Tagged tag="screen-open-enquiry">
      <RouteAppWrapper isXs={isXs}>
        <AppSurface>
          <Suspense>
            <NewEnquiry orderLineId={Number(orderid)} onReset={onReset} isXs={isXs} totalSteps={3} />
          </Suspense>
        </AppSurface>
      </RouteAppWrapper>
    </Tagged>
  );
}

Component.displayName = 'Enquiry';
